import React from 'react';
import type { PreloadedQuery } from 'react-relay';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import type { ui_NotificationsPageAndProjectQuery } from '@atlassian/jira-relay/src/__generated__/ui_NotificationsPageAndProjectQuery.graphql';
import { useQueryParam } from '@atlassian/react-resource-router';
import { NotificationsPage } from './ui/index.tsx';

export function NotificationsPersonalSettings({
	queryReference,
}: {
	queryReference: PreloadedQuery<ui_NotificationsPageAndProjectQuery>;
}) {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const pageViewFromEmail = window?.location?.hash?.substring(1) === 'emailpreferences';
	const [engagement = ''] = useQueryParam('engagement');

	return (
		<JSErrorBoundary
			id="notificationsSettings"
			packageName="jiraPersonalSettingsNotifications"
			teamName="jira-notifications-platform"
		>
			<ContextualAnalyticsData
				sourceName="personalSettingsNotifications"
				sourceType={SCREEN}
				attributes={{ pageViewFromEmail, engagement }}
			>
				<NotificationsPage
					queryReference={
						// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
						queryReference as PreloadedQuery<ui_NotificationsPageAndProjectQuery>
					}
				/>
			</ContextualAnalyticsData>
		</JSErrorBoundary>
	);
}
